<mat-toolbar color="primary">
  <mat-toolbar-row class="w-full flex flex-row">
    <span>Device Registration</span>
    <span class="flex-1"></span>
    <button matButton (click)="logout.emit()">Logout</button>
  </mat-toolbar-row>
</mat-toolbar>
